// eslint-disable-next-line import/prefer-default-export
export const ucFirst = (str: string): string => (
    str.charAt(0).toUpperCase() + str.slice(1)
);
